import checkout from "./Form";

const {
  formField: {
    // datas
    name,
		email,
		company,
  },
} = checkout;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // datas
  [name.name]: "",
  [email.name]: "",
  [company.name]: "",
};